import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "expandIcon", "collapseIcon"]

  connect() {
    this.checkOverflow()

    this.boundDrawHandler = (e) => {
      if (e.target.contains(this.element)) this.checkOverflow()
    }
    document.addEventListener("datatables:draw", this.boundDrawHandler)

    // Re-check on window resize with debounce
    this.resizeHandler = this.debounce(() => this.checkOverflow(), 100, "resizeTimeout")
    window.addEventListener("resize", this.resizeHandler)
  }

  disconnect() {
    document.removeEventListener("datatables:draw", this.boundDrawHandler)
    window.removeEventListener("resize", this.resizeHandler)
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout)
  }

  debounce(func, wait, timeoutKey) {
    return (...args) => {
      if (this[timeoutKey]) clearTimeout(this[timeoutKey])
      this[timeoutKey] = setTimeout(() => {
        this[timeoutKey] = null
        func.apply(this, args)
      }, wait)
    }
  }

  checkOverflow() {
    if (!this.hasContentTarget) return

    const isExpanded = this.element.classList.contains('expanded')

    if (isExpanded) {
      if (this.hasExpandIconTarget) {
        this.expandIconTarget.style.display = 'none'
      }
      if (this.hasCollapseIconTarget) {
        this.collapseIconTarget.style.display = 'inline-flex'
      }
      return
    }

    // Check if text is overflowing
    const { scrollWidth, clientWidth } = this.contentTarget
    const isOverflowing = scrollWidth > clientWidth

    if (this.hasExpandIconTarget) {
      this.expandIconTarget.style.display = isOverflowing ? 'inline-flex' : 'none'
    }
    if (this.hasCollapseIconTarget) {
      this.collapseIconTarget.style.display = 'none'
    }
  }

  toggle() {
    const isExpanded = this.element.classList.contains('expanded')

    if (isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.element.classList.add('expanded')

    if (this.hasExpandIconTarget) {
      this.expandIconTarget.style.display = 'none'
    }
    if (this.hasCollapseIconTarget) {
      this.collapseIconTarget.style.display = 'inline-flex'
    }
  }

  collapse() {
    this.element.classList.remove('expanded')

    if (this.hasCollapseIconTarget) {
      this.collapseIconTarget.style.display = 'none'
    }

    // Re-check overflow after collapsing
    requestAnimationFrame(() => {
      this.checkOverflow()
    })
  }
}
